import { axiosFactory } from '../../../../client';
import * as ROUTES from './routes';
import { AmendmentTransactionInfo, CandidateDetails } from '../../model';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api/amendment`;
const timeout = 5000;

export const subjectCandidateClient = axiosFactory(baseURL, timeout);

export const getAmendmentReviewSubject = (uuid: string) =>
  subjectCandidateClient.get(ROUTES.GET_AMENDMENT_REVIEW_SUBJECT(uuid));

export const getAmendmentCandidateProfile = (uuid: string) =>
  subjectCandidateClient.get<CandidateDetails>(ROUTES.GET_AMENDMENT_CANDIDATE_PROFILE(uuid));

export const getAmendmentTransactionInfo = (uuid: string) =>
  subjectCandidateClient.get<AmendmentTransactionInfo>(ROUTES.GET_AMENDMENT_TRANSACTION_INFO(uuid));
